import React from "react";
import { InfoVert } from "../";
import { scoreFactors } from "_helpers/experian";
import "./Score.scss";

function Score(props) {
  const { report } = props;
  const riskModel = report?.riskModel?.[0];

  return (
    <div id={props.id} className="wzrd-box score">
      <div className="wzrd-header">
        <h3>Score Summary</h3>
      </div>
      <div className="wzrd-body">
        <div className="columns" style={{ marginBottom: "24px" }}>
          <InfoVert title="Risk Model">
            {riskModel?.modelIndicator === "F9" ? "FICO Score 9" : "Risk Model"}
          </InfoVert>
          {riskModel?.score && (
            <InfoVert title="Score">{parseInt(riskModel?.score)}</InfoVert>
          )}
        </div>
        {riskModel?.scoreFactors && riskModel.scoreFactors.length > 0 && (
          <table>
            <thead>
              <tr>
                <th>Rank</th>
                <th>Code</th>
                <th>Score Factor Description</th>
              </tr>
            </thead>
            <tbody>
              {riskModel?.scoreFactors?.map((factor, i) => (
                <tr key={`sf-${i}`}>
                  <td>{factor.importance}</td>
                  <td>{parseInt(factor.code)}</td>
                  <td>
                    {scoreFactors[parseInt(factor.code)] || "Unknown factor"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default Score;
